import React, { useState } from 'react'
import PropTypes from 'prop-types'
import './head.less'

export default function Head({ changeTab = () => {} }) {
	let [selectEleIndex, setSelectEleIndex] = useState(0)
	const contentList = ['境内', '境外/港澳台']
	function _headClick(which) {
		setSelectEleIndex(which)
		changeTab(which)
	}

	return (
		<div className='component_city-select-head'>
			{contentList.map((item, index) => {
				return (
					<div key={index} className='city-select-ele' onClick={() => _headClick(index)}>
						<div
							className={
								selectEleIndex === index
									? 'city-select-item city-select-item-selected'
									: 'city-select-item'
							}
						>
							{item}
						</div>
					</div>
				)
			})}
		</div>
	)
}

Head.propTypes = {
	changeTab: PropTypes.func,
}
